import * as React from 'react';

import StaticPageLayout from 'components/static-site/StaticPageLayout';
import {
  createStaticPageProps,
  staticPageFields,
  type StaticPageProps,
} from 'components/static-site/staticPageProps';
import type { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import type { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';
import type { NextRouter } from 'next/router';

import AccountFormPage from '../components/account/AccountFormPage';
import { pickAccountFormConfig, pickString } from '../components/account/accountFormPageParams';

const Login: React.FC<NextRouter> = (props) => {
  const { config, redirectTo, emailPrefill, updatedPassword } = props.query;
  return (
    <AccountFormPage
      config={pickAccountFormConfig(config)}
      redirectTo={pickString(redirectTo)}
      emailPrefill={pickString(emailPrefill)}
      updatedPassword={pickString(updatedPassword) === 'true'}
    />
  );
};

const loginPageFields = staticPageFields(
  'login',
  'Log in | Opendoor',
  'Log in to your Opendoor account.',
);

export const getServerSideProps: CacheSafeGetServerSideProps<StaticPageProps> = async () => ({
  props: createStaticPageProps(loginPageFields),
});

export default withRouter((context: React.PropsWithChildren<WithRouterProps> & StaticPageProps) => {
  return (
    <StaticPageLayout {...context} hideFooter>
      <Login {...context.router} />
    </StaticPageLayout>
  );
});
